import * as React from "react";
import TabbedBarChart from "./TabbedBarChart";
import SimpleLineChart from "./SimpleLineChart";
import TabbedLineChart from "./TabbedLineChart";
import SimpleBarChart from "./SimpleBarChart";
import PieChartDoughnut from "./PieChartDoughnut";
import StackedBarChart from "./StackedBarChart";
import ScatterBarChart from "./ScatterBarChart";
import CustomMultiLineChart from "./CustomMultiLineChart";
import HorizontalBarChart from "./HorizontalBarChart";
import PieChartWithCustomizedLabel from "./PieChartWithCustomizedLabel";

const SimpleCharts = ({ chart_data, index, total }) => {

    const isFullWidth = index === total - 1 && total % 2 !== 0;
    const { chartType, type, chart_type, xAxis, yAxis, daily, weekly, data } = chart_data;
    const chartViewType = chartType || type || chart_type;
    const isMultipleTabs = daily && weekly;

    const renderChart = () => {
        //console.log(chart_data)
        if (chartType === 'bar') {
            return isMultipleTabs
                ? <TabbedBarChart chart_data={chart_data} isFullWidth={isFullWidth} />
                : <SimpleBarChart chart_data={chart_data} isFullWidth={isFullWidth} />;
        } else if (chartType === 'horizontal_bar') {
            return <HorizontalBarChart chart_data={chart_data} isFullWidth={isFullWidth} />;
        } else if (chartType === 'line') {
            return isMultipleTabs
                ? <TabbedLineChart chart_data={chart_data} isFullWidth={isFullWidth} />
                : <SimpleLineChart chart_data={chart_data} isFullWidth={isFullWidth} isArea={false} />;
        } else if (chartType === 'area') {
            return <SimpleLineChart chart_data={chart_data} isFullWidth={isFullWidth} isArea={true} />;
        } else if (chartType === 'doughnut' || chartType === 'donut') {
            return <PieChartDoughnut chart_data={chart_data} isFullWidth={isFullWidth} />;
        } else if (chartType === 'histogram') {
            return isMultipleTabs
                ? <TabbedLineChart chart_data={chart_data} isFullWidth={isFullWidth} />
                : <SimpleLineChart chart_data={chart_data} isFullWidth={isFullWidth} isArea={false} />;
        } else if (chartType === 'stackedBar' || chartType === 'stacked_bar') {
            return <StackedBarChart chart_data={chart_data} isFullWidth={isFullWidth} />;
        } else if (chartType === 'scatter') {
            return <ScatterBarChart chart_data={chart_data} isFullWidth={isFullWidth} />;
        } else if (chartType === 'treemap') {
            //return <TreemapChart chart_data={chart_data} isFullWidth={isFullWidth} />;
            //return <PieChartWithCustomizedLabel chart_data={chart_data} isFullWidth={isFullWidth} />;
            return <ScatterBarChart chart_data={chart_data} isFullWidth={isFullWidth} />;
        } else if (chartType === 'multi_line') {
            return <CustomMultiLineChart chart_data={chart_data} isFullWidth={isFullWidth} />;
        } else {
            //return <VerticalSimpleBarChart chart_data={chart_data} isFullWidth={isFullWidth} layout="vertical" />;
        }
    };

    return (
        <div>
            {renderChart()}
        </div>
    );
}

export default SimpleCharts;